import React, {Component} from 'react';
import MarketingAlertHeader from './marketing_alerts/marketing_alert_header';

export default class HeaderSticker extends Component {
  render() {
    return (
      <MarketingAlertHeader data={this.props.marketingAlertHeader}/>
    )
  }
}